import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { LucideIcon } from 'lucide-react';

interface BreakdownItem {
  item: string;
  allocation: number;
}

interface FundCategory {
  category: string;
  amount: number;
  percentage: number;
  icon: LucideIcon;
  description: string;
  breakdown: BreakdownItem[];
  color: string;
}

interface FundBreakdownProps {
  fundAllocation: FundCategory[];
}

export const FundBreakdown = ({ fundAllocation }: FundBreakdownProps) => {
  return (
    <div className="grid gap-6 mt-8">
      {fundAllocation.map((category, index) => (
        <Card key={index} className="overflow-hidden">
          <div className="p-6">
            <div className="flex items-center gap-4 mb-4">
              <div 
                className="p-3 rounded-lg"
                style={{ backgroundColor: `${category.color}20` }}
              >
                <category.icon 
                  className="w-6 h-6"
                  style={{ color: category.color }}
                />
              </div>
              <div className="flex-1">
                <div className="flex justify-between items-center mb-2">
                  <h3 className="font-semibold text-lg">{category.category}</h3>
                </div>
                <Progress value={category.percentage} className="h-2" />
                <div className="flex justify-between text-sm text-gray-600 mt-1">
                  <span>{category.percentage}% of total funding</span>
                </div>
              </div>
            </div>
            
            <p className="text-gray-600 mb-4">{category.description}</p>
            
            <div className="bg-gray-50 rounded-lg p-4">
              <h4 className="font-semibold mb-3">Detailed Breakdown</h4>
              <div className="space-y-2">
                {category.breakdown.map((item, idx) => (
                  <div key={idx} className="text-gray-600 border-b border-gray-100 last:border-0 py-1">
                    {item.item}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};